import { Constant } from '@genial/config';
import { Utils } from '@genial/utils';
import { atom } from 'recoil';

import { blankUserSession } from './constants';
import { ApplicationSession } from './types';
import { buildSessionAtomFromTokens } from './utils';

export const sessionState = atom<ApplicationSession>({
  key: 'Session/State',
  default: new Promise((resolve) => {
    Promise.all([
      Utils.Storage.GetItem(Constant.TokenKey),
      Utils.Storage.GetItem(Constant.RefreshTokenKey),
      Utils.Storage.GetItem(Constant.RefreshTokenKeyExpiration),
      Utils.Storage.GetItem(Constant.UserProfileKey),
    ])
      .then(([jwtToken, refreshToken, expirationRefreshToken, userProfile]) => {
        if (jwtToken && refreshToken && expirationRefreshToken && userProfile) {
          const sessionData = buildSessionAtomFromTokens(
            jwtToken,
            refreshToken,
            expirationRefreshToken,
            JSON.parse(userProfile)
          );

          resolve(sessionData);
          return;
        }

        resolve({ ...blankUserSession });
      })
      .catch((_error) => {
        resolve({ ...blankUserSession });
      });
  }),
});

export const hasRefreshTokenObserver = atom<boolean>({
  key: 'hasRefreshTokenObserver',
  default: false,
});
